import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActionsPanel = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      label: 'Nova Consulta',
      description: 'Iniciar nova consulta tributária',
      icon: 'FilePlus',
      color: 'var(--color-primary)',
      onClick: () => navigate('/new-tax-consultation-form'),
      shortcut: 'Alt+N'
    },
    {
      label: 'Importação em Lote',
      description: 'Importar produtos via CSV/Excel',
      icon: 'Upload',
      color: 'var(--color-accent)',
      onClick: () => navigate('/new-tax-consultation-form?import=true'),
      shortcut: 'Alt+I'
    },
    {
      label: 'Exportar Dados',
      description: 'Exportar consultas para Excel',
      icon: 'Download',
      color: 'var(--color-success)',
      onClick: () => {
        console.log('Exportar dados');
      },
      shortcut: 'Alt+E'
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">
        Ações Rápidas
      </h3>
      <div className="space-y-3">
        {quickActions?.map((action) => (
          <Button
            key={action?.label}
            variant="outline"
            fullWidth
            iconName={action?.icon}
            iconPosition="left"
            onClick={action?.onClick}
            className="justify-start"
          >
            <div className="flex-1 text-left">
              <div className="font-medium">{action?.label}</div>
              <div className="text-xs text-muted-foreground mt-0.5">
                {action?.description}
              </div>
            </div>
            <span className="text-xs text-muted-foreground font-mono">
              {action?.shortcut}
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsPanel;